import {atom} from 'recoil';

import {getLocalStorageSideEffect} from '@ELib/utilities/recoilLocalStorageUtils';

export type ColumnElement = {
  name: string;
  active: boolean;
  defaultHidden: boolean;
};

type ColumnState = {
  [tableKey: string]: ColumnElement[];
};

export const columnState = atom<ColumnState>({
  key: 'ETableColumns',
  default: {},
  effects: [getLocalStorageSideEffect('ETableColumnsConfig')],
});
